import styled from 'styled-components';
import star from './img/star.png';

export const Slide = styled.div`
	width: 100%;
	padding: 20px;
	border: 2px solid rgba(219, 217, 247, 1);
	border-radius: 5px;
`;

export const Header = styled.div`
	margin-bottom: 10px;
	display: flex;
`;

export const Avatar = styled.img`
	width: 40px;
	height: 40px;
	margin-right: 10px;
`;

export const UserName = styled.div`
	h4 {
		color: #339;
		font-size: 16px;
		font-weight: 600;
		line-height: normal;
		position: relative;
		display: flex;
		align-items: center;
		margin-bottom: 6px;
	}

	h4:after {
		content: '';
		display: block;
		background: url(${star}) no-repeat;
		background-size: contain;
		background-position: center;
		width: 21px;
		height: 18px;
		margin-right: 5px;
	}

	p {
		font-size: 14px;
		color: rgba(26, 26, 26, 1);
		opacity: 0.7;
		display: flex;
		align-items: center;
		justify-content: flex-start;

		span {
			font-weight: 700;
		}
	}

	img {
		width: 15px;
		height: 15px;
		margin-right: 5px;
	}
`;

export const Review = styled.p`
	color: #1a1a1a;
	font-size: 16px;
	font-weight: 400;
	line-height: normal;
`;
